import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import { Item } from "features/preauthorization/components/NestedPayerResponse";

const ClaimProviderEncounter = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const encounter = viewClaimInfo?.payload_json;

  const providerReqEncounter = viewClaimInfo?.provider_request?.encounter

  const itemDetails = [
    {
      id: 1,
      title: "Triage Category",
      value: providerReqEncounter?.enct_trgctgname,
    },
    {
      id: 1,
      title: "Emergency Arrival Code",
      value: providerReqEncounter?.enct_emrgarvlname,
    },
    {
      id: 1,
      title: "Care Type",
      value: providerReqEncounter?.enct_servtypename,
    },
    {
      id: 1,
      title: "Emergency Department Disposition",
      value: providerReqEncounter?.enct_emrgdeptdispname,
    },
    {
      id: 1,
      title: "Emergency Service Date",
      value: providerReqEncounter?.enct_emergservst,
    },
    {
      id: 1,
      title: "Cause Of Death",
      value: providerReqEncounter?.enct_csedth,
    },
    {
      id: 3,
      title: "Encounter Class",
      value: providerReqEncounter?.enct_clsname,
    },
    {
      id: 4,
      title: "Encounter Status",
      value: providerReqEncounter?.enct_status,
    },
    {
      id: 5,
      title: "Service Event Type",
      value: providerReqEncounter?.enct_sevnttypname,
    },
    {
      id: 5,
      title: "Act Priorty",
      value: "Elective",
    },
    {
      id: 9,
      title: "Admission Specilaity",
      value: providerReqEncounter?.enct_admnspecltyname,
    },

    {
      id: 9,
      title: "Intend Length of stay",
      value: providerReqEncounter?.enct_intdlghstyname,
    },

    {
      id: 5,
      title: "Discharge Speciality",
      value: encounter?.enct_discgspecltyname,
    },
    {
      id: 5,
      title: "Admit Source",
      value: encounter?.enct_admsrcename,
    },

  ];

  return (
    <motion.div
      className="rounded p-3 position-relative mt-3 mb-3"
      style={{ border: "2px solid #d9f8eb" }}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Encounter</span>
        </span>
      </div>

      {/* Dates Section */}
      <Row className="mt-3">
        {viewClaimInfo?.payload_json?.enct_stdate && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Admission Date</span>
              <span className="fw-normal text-600 fs-10">
                {moment(encounter?.enct_stdate).format(
                  "DD-MM-YYYY , hh:mm:ss A"
                )}
              </span>
            </div>
          </Col>
        )}
        {viewClaimInfo?.payload_json?.enct_eddate && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Discharge Date</span>
              <span className="fw-normal text-600 fs-10">
                {moment(encounter?.enct_eddate).format(
                  "DD-MM-YYYY , hh:mm:ss A"
                )}
              </span>
            </div>
          </Col>
        )}
        {viewClaimInfo?.payload_json?.enct_trgdte && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Triage Date</span>
              <span className="fw-normal text-400 fs-10">
                {encounter?.enct_trgdte
                  ? moment(encounter?.enct_trgdte).format(
                    "DD-MM-YYYY , hh:mm:ss A"
                  )
                  : ""}
              </span>
            </div>
          </Col>
        )}
      </Row>

      <hr />

      {/* Dynamic Info Section */}
      <Row>
        {itemDetails
          .filter((item) => item.value)
          .map((item) => (
            <Col key={item.id} xs={12} md={4} xl={3} className="mb-3">
              <Item title={item.title} value={item.value} />
            </Col>
          ))}
      </Row>
    </motion.div>
  );
};

export default ClaimProviderEncounter;
